<template>
	<v-dialog :max-width="700" v-model="showPopup" :persistent="true">
		<v-card>
			<div class="popup-header text-center">
				<h2>Affiliate Status Notice</h2>
				<v-icon class="close-icon cursor-pointer" @click="closePopup">{{ closeIcon }}</v-icon>
			</div>
			<v-card-text class="py-0 px-0 pr-3">
				<div class="content-section mt-1 mb-1 pa-3">
					<v-row v-if="plan">
						<v-col cols="12" md="8" xl="9">
							<p class="fs--14 fw--600 white--text">
								Please note that since you're not yet a
								<a
									class="blueWaves--text"
									href="https://help.twitch.tv/s/article/joining-the-affiliate-program?language=en_US"
									target="_blank">
									Twitch Affiliate
								</a>
								, some Premium upgrades requiring the use of Twitch Bits will be unavailable after
								upgrade. The available upgrades for your account status type are listed below, and
								additional upgrades will unlock once you achieve Affiliate status.
							</p>

							<div class="benefits">
								<div v-if="plan.customSlots > 0" class="d-flex align-center mb-2">
									<v-icon color="lightGreen" width="14" class="mr-1">
										{{ checkIcon }}
									</v-icon>
									<span class="fs--13 fw--500 fieldFore--text">
										<strong :class="textColorClass">+{{ plan.customSlots }}</strong>
										Custom Sticker Slots
									</span>
								</div>
								<div v-if="plan.rewardSlots > 0" class="d-flex align-center mb-2">
									<v-icon color="red" width="14" class="mr-1">
										{{ closeThick }}
									</v-icon>
									<span class="fs--13 fw--500 fieldFore--text">
										<strong :class="textColorClass">+{{ plan.rewardSlots }}</strong>
										Reward Sticker Slots
									</span>
								</div>
								<div v-if="plan.ttsVoiceSlots > 0" class="d-flex align-center mb-2">
									<v-icon color="red" width="14" class="mr-1">
										{{ closeThick }}
									</v-icon>
									<span class="fs--13 fw--500 fieldFore--text">
										<strong :class="textColorClass">+{{ plan.ttsVoiceSlots }}</strong>
										Personal TTS Voice Model Slots
									</span>
								</div>
								<div v-if="plan.ttsStickerSlots > 0" class="d-flex align-center mb-2">
									<v-icon color="red" width="14" class="mr-1">
										{{ closeThick }}
									</v-icon>
									<span class="fs--13 fw--500 fieldFore--text">
										<strong :class="textColorClass">+{{ plan.ttsStickerSlots }}</strong>
										Personal TTS Sticker Slots
									</span>
								</div>
								<div v-if="plan.ttsMessageSize > 0" class="d-flex align-center mb-2">
									<v-icon color="red" width="14" class="mr-1">
										{{ closeThick }}
									</v-icon>
									<span class="fs--13 fw--500 fieldFore--text">
										<strong :class="textColorClass">+{{ plan.ttsMessageSize }}</strong>
										TTS Message Limit (Total of {{ 256 + plan.ttsMessageSize }} Characters Per TTS
										Message)
									</span>
								</div>
								<div v-if="plan.customPartyMusic" class="d-flex align-center mb-2">
									<v-icon color="red" width="14" class="mr-1">
										{{ closeThick }}
									</v-icon>
									<span class="fs--13 fw--500 fieldFore--text">
										<strong :class="textColorClass">Personalize</strong>
										Your Sticker Party Music!
									</span>
								</div>
								<div v-if="plan.stickerSparkles" class="d-flex align-center mb-2">
									<v-icon color="lightGreen" width="14" class="mr-1">
										{{ checkIcon }}
									</v-icon>
									<span class="fs--13 fw--500 fieldFore--text">
										<strong :class="textColorClass">Sticker Sparkles!</strong>
									</span>
								</div>
							</div>
						</v-col>
						<v-col cols="12" md="4" xl="3" class="d-flex flex-column align-center justify-center">
							<img :src="planImage" width="260" />
							<strong class="fs--20 mt-3 text-center" :class="textColorClass">{{ getPlanName }}</strong>
						</v-col>

						<v-col cols="12" class="text-center mb-3">
							<v-btn color="pink" class="fw--700" depressed @click="upgrade">
								Got it! Proceed to Upgrade
							</v-btn>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { computed, watch } from '@vue/composition-api';
import { mdiClose, mdiCheckBold, mdiCloseThick } from '@mdi/js';
import store from '@/store';
import { SubPlan } from '@/utils/constants.js';

export default {
	props: {
		modal: {
			type: Boolean,
			default: false,
		},
		plan: {
			type: Object,
			default: null,
		},
		current: {
			type: Object,
			default: null,
		},
	},
	setup(props, { emit }) {
		const subTier = computed(() => store.state.app.subTier);
		const showPopup = computed({
			get() {
				return props.modal;
			},
			set(newValue) {
				if (!newValue) {
					emit('close', true);
				}
			},
		});

		const planImage = computed(() => {
			return require(`@/assets/images/mascot/Tier ${props.plan.tier}.png`);
		});

		const getPlanName = computed(() => {
			if (props.plan.tier === SubPlan.PREMIUM) {
				return `Premium`;
			} else if (props.plan.tier === SubPlan.PLUS) {
				return `Premium Plus`;
			} else if (props.plan.tier === SubPlan.EXTREME) {
				return `Premium Xtreme`;
			}
		});

		const closePopup = () => {
			emit('close', true);
		};

		const upgrade = () => {
			emit('upgrade', props.plan);
		};
		return {
			closePopup,
			showPopup,
			planImage,
			getPlanName,
			upgrade,
			textColorClass: computed(() => (props.plan ? props.plan.primaryColor + '--text' : 'white--text')),
			checkIcon: mdiCheckBold,
			closeThick: mdiCloseThick,
			closeIcon: mdiClose,
		};
	},
};
</script>

<style lang="scss" scoped>
.popup-header {
	position: relative;
	padding: 8px 0;
	background: url('../../../assets/images/backgrounds/sticker-upload-header.png');
	background-repeat: no-repeat;
	background-size: cover;
}

.close-icon {
	position: absolute;
	top: 15px;
	right: 15px;
}

.content-section {
	width: 95%;
	margin: auto;
}
</style>
